<template>
  <div v-loading="loading">
    <el-form ref="from_params" :model="searchParams">
      <QS-search maxLine="1">
        <el-form-item label="方案ID" prop="id">
          <el-input
            v-number:integer
            v-model="searchParams.id"
            placeholder="请输入方案ID"
            clearable
          />
        </el-form-item>
        <el-form-item label="方案名称" prop="name">
          <el-input
            maxlength="50"
            v-model="searchParams.name"
            placeholder="请输入方案名称"
            clearable
          />
        </el-form-item>
        <CarBrandSeriesModel
          ref="carBrandSeriesModelRef"
          :showModel="true"
          v-model="searchParams.brandSeriesModel" />
        <el-form-item label="方案所属城市" prop="adcode">
          <el-select
            v-model="searchParams.adcode"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              v-for="item in cityList"
              :key="item.adcode"
              :label="item.city"
              :value="item.adcode"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="车龄" prop="carAge">
          <el-select
            v-model="searchParams.carAge"
            clearable
            placeholder="请选择车龄"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="item in carAgeOptions"
              :label="item.name"
              :value="item.code"
              :key="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否有车证" prop="hasDrivingLicense">
          <el-select
            v-model="searchParams.hasDrivingLicense"
            clearable
            placeholder="请选择"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="item in DRIVING_LICENSE_OPTIONS"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="租赁类型" prop="rentCategory">
          <el-select
            v-model="searchParams.rentCategory"
            clearable
            placeholder="请选择租赁类型"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="(label, value) in categoryList"
              :label="label"
              :value="Number(value)"
              :key="value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="收款方式" prop="paymentMethod">
          <el-select
            v-model="searchParams.paymentMethod"
            clearable
            placeholder="请选择收款方式"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="item in PAYMENT_METHOD_OPTIONS"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="关联活动" prop="hasCampaign">
          <el-select
            v-model="searchParams.hasCampaign"
            clearable
            placeholder="请选择"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="item in CAMPAIGN_BIND_OPTIONS"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="可发车门店" prop="storeIds">
          <el-select
            v-model="searchParams.storeIds"
            clearable
            filterable
            multiple
            collapse-tags
            placeholder="请选择门店"
          >
            <el-option
              v-for="item in storeList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="方案状态" prop="state">
          <el-select
            v-model="searchParams.state"
            clearable
            placeholder="请选择方案状态"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in PLAN_STATUS_OPTIONS"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template slot="moreBtn">
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              class="whole_contract_btn"
              @click="searchHandle"
              :loading="oLoading.search"
            >查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="whole_contract_btn" @click="goReset">重置</el-button>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>
    <div class="operation-box" v-if="judgePermission('for_rent_config_ren_plan_create')">
      <el-button type="primary" @click="goAddPage">新增方案</el-button>
    </div>

    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <QS-common-table ref="tableComponent"
      :data="tableData"
      :columns="tableColumns"
      :pagination="pagination"
      @change="paginationChange"
    >
    </QS-common-table>
  </div>
</template>
<script>
import configData, { STATE_ENUM, TYPE_ENUM, DIALOG_CONFIG } from './config'
// eslint-disable-next-line import/no-cycle
import {
  getLeaseSchemeList,
  updateLeaseSchemeState,
  deleteLeaseScheme,
} from '@/api/domain/leaseScheme'
import {
  DRIVING_LICENSE_OPTIONS,
  CAMPAIGN_BIND_OPTIONS,
  PAYMENT_METHOD_OPTIONS,
  PLAN_STATUS_OPTIONS,
} from '../const'
import { categoryList } from '@/store/dict/rentPlanDict'
import { getEnum } from '@/api/global'
import { storeList } from '@/api/domain/shop'

export default {
  components: {},
  data() {
    const { tableColumns } = configData.call(this)
    return {
      tableColumns,
      loading: false,
      oLoading: {
        search: false,
      },
      dialogWrap: {
        id: '',
        type: -1,
        title: '提示',
        contentTxt: '',
        sureBtnText: '',
      },
      tableData: [],
      pagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      searchParams: {
        id: '',
        name: '',
        state: '',
        rentCategory: '',
        paymentMethod: '',
        carAge: '',
        hasDrivingLicense: '',
        hasCampaign: '',
        storeIds: [],
        adcode: '',
        brandSeriesModel: {},
      },
      carAgeOptions: [],
      storeList: [],
      categoryList,
      DRIVING_LICENSE_OPTIONS,
      CAMPAIGN_BIND_OPTIONS,
      PAYMENT_METHOD_OPTIONS,
      PLAN_STATUS_OPTIONS,
    }
  },
  computed: {
    cityList() {
      return this.$store.getters.allCities
    },
  },
  created() {
    this.initQueryValue()
  },
  mounted() {
    this.fetchCarAgeOptions()
    this.fetchStoreList()
  },

  activated() {
    this.getList()
  },
  methods: {
    initQueryValue() {
      Object.keys(this.$route.query).forEach((key) => {
        let _val = this.$route.query[key]
        if (
          [
            'modelId',
            'state',
            'rentCategory',
            'hasDrivingLicense',
            'hasCampaign',
            'carAge',
          ].includes(key)
        ) {
          _val = Number(_val)
        }
        if (key === 'storeIds' && typeof _val === 'string') {
          _val = _val.split(',').map(Number)
        }
        const hasKey = Object.prototype.hasOwnProperty.call(this.searchParams, key)
        if (this.$route.query[key] && hasKey) {
          this.searchParams[key] = _val
        }
      })
      const { pageSize, pageNum } = this.$route.query
      this.pagination = {
        ...this.pagination,
        pageSize: pageSize ? Number(pageSize) : 10,
        pageNum: pageNum ? Number(pageNum) : 1,
      }
    },
    // 重置
    goReset() {
      this.pagination.pageNum = 1
      this.$refs.from_params.resetFields()
      this.$refs.carBrandSeriesModelRef.reset()
      this.searchParams = {
        id: '',
        name: '',
        state: '',
        rentCategory: '',
        paymentMethod: '',
        carAge: '',
        hasDrivingLicense: '',
        hasCampaign: '',
        storeIds: [],
        adcode: '',
        brandSeriesModel: {},
      }
      this.$router.replace({ path: this.$route.path })
      this.searchHandle()
    },

    // 搜索事件
    searchHandle() {
      this.pagination.pageNum = 1
      this.getList()
    },

    // 获取列表
    getList() {
      this.oLoading.search = true
      const { brandSeriesModel } = this.searchParams
      const { state, rentCategory, id, name } = this.searchParams
      const params = {
        id: id || undefined,
        name: name || undefined,
        state: state !== '' ? state : undefined,
        rentCategory: rentCategory !== '' ? rentCategory : undefined,
        payMode: this.searchParams.paymentMethod
          ? {
            MONTH_FULL: 4,
            MONTH_NATURAL: 5,
            WEEK_FULL: 3,
            WEEK_NATURAL: 12,
            DAY: 10,
          }[this.searchParams.paymentMethod]
          : undefined,
        age: this.searchParams.carAge !== '' ? this.searchParams.carAge : undefined,
        carCert: this.searchParams.hasDrivingLicense !== '' ? this.searchParams.hasDrivingLicense : undefined,
        hasActivity: this.searchParams.hasCampaign !== '' ? this.searchParams.hasCampaign : undefined,
        storeIds: this.searchParams.storeIds.length ? this.searchParams.storeIds : undefined,
        cityCodes: this.searchParams.adcode ? [this.searchParams.adcode] : undefined,
        brandId: brandSeriesModel.brandId || undefined,
        seriesId: brandSeriesModel.seriesId || undefined,
        modelId: brandSeriesModel.modelId || undefined,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      }

      getLeaseSchemeList(params).then(({ code, data }) => {
        if (code === 1) {
          this.pagination.total = data.totalNum
          this.tableData = data.items || []
        } else {
          this.pagination.total = 0
          this.tableData = []
        }
      }).catch(() => {
        this.pagination.total = 0
        this.tableData = []
      }).finally(() => {
        this.oLoading.search = false
      })
    },
    paginationChange(payload) {
      const { pagination } = payload
      this.pagination.pageNum = pagination.pageNum
      this.pagination.pageSize = pagination.pageSize
      this.getList()
    },
    // eslint-disable-next-line vue/no-unused-properties
    async clickHandle(row, { type }) {
      this.dialogWrap.id = row.id

      if (type === TYPE_ENUM.ADDOREDIT) {
        this.dialogWrap = { ...this.dialogWrap, ...DIALOG_CONFIG[row.state] }
      }

      try {
        await this.$confirm(
          `${this.dialogWrap.contentTxt}【${row.name}】`,
          this.dialogWrap.title,
          {
            confirmButtonText: this.dialogWrap.sureBtnText,
            cancelButtonText: '取消',
          },
        )
      } catch {
        return
      }
      this.submitHandle(row)
    },

    // 去详情页
    // eslint-disable-next-line vue/no-unused-properties
    goDetail(row) {
      if (!this.judgePermission('for_rent_config_ren_plan_detail')) {
        return this.$message.error('暂无权限，请联系管理员开通')
      }
      this.$router.push({
        path: '/car_to_lease/leaseScheme/detail',
        query: {
          id: row.id,
        },
      })
    },

    // 提交事件
    submitHandle(row) {
      if (this.dialogWrap.type === TYPE_ENUM.ADDOREDIT) {
        const newState = row.state === STATE_ENUM.ABLE ? 0 : 10
        this.updateHandle(row, newState)
      }
    },

    // 上下架事件
    updateHandle(row, state) {
      this.loading = true
      updateLeaseSchemeState({ id: row.id, state }).then(({ code }) => {
        if (code === 1) {
          this.$message.success('修改成功')
          this.oLoading.search = true
          setTimeout(() => {
            this.oLoading.search = false
            this.getList()
          }, 3000)
        }
      }).catch((error) => {
        if (error.code === 22051) {
          this.$confirm(
            '当前有待确认订单，请将订单置为终态后再行下架',
            '方案下架提示',
            {
              showConfirmButton: true,
              confirmButtonText: '查看订单列表',
              cancelButtonText: '取消',
              type: 'warning',
            },
          ).then(() => {
            this.$router.push({ path: '/workbench/rentOrder/list', query: { planId: row.id } })
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          }).catch(() => {})
        } else if (error.code === 22052) {
          this.$confirm(
            '租赁方案无法上架，点击【去编辑】选择"启用"的合同模板后进行上架',
            '方案上架提示',
            {
              confirmButtonText: '去编辑',
              cancelButtonText: '取消',
              type: 'warning',
            },
          ).then(() => {
            this.goEditPage(row)
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          }).catch(() => {})
        }
      }).finally(() => {
        this.loading = false
      })
    },

    // eslint-disable-next-line vue/no-unused-properties
    async deleteHandle(row) {
      try {
        await this.$confirm(`确认删除方案【${row.name}】？删除后不可恢复。`, '删除确认', {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning',
        })
      } catch {
        return
      }
      this.loading = true
      const { code } = await deleteLeaseScheme({ id: row.id })
      this.loading = false
      if (code === 1) {
        this.$message.success('删除成功')
        this.oLoading.search = true
        setTimeout(() => {
          this.oLoading.search = false
          this.getList()
        }, 3000)
      }
    },

    /**
     * @去新增页面
     * */
    goAddPage() {
      this.$router.push({ path: '/car_to_lease/leaseScheme/add' })
    },
    // 去编辑页面
    goEditPage(rowData) {
      const { pageSize, pageNum } = this.pagination
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.searchParams, pageSize, pageNum },
      })
      this.$nextTick(() => {
        this.$router.push({
          path: '/car_to_lease/leaseScheme/edit',
          query: { id: rowData.id },
        })
      })
    },
    // 复制 ./config/index.js有用
    // eslint-disable-next-line vue/no-unused-properties
    copy(rowData) {
      this.$router.push({
        path: '/car_to_lease/leaseScheme/copy',
        query: { id: rowData.id },
      })
    },

    async fetchCarAgeOptions() {
      const { code, data } = await getEnum({ type: 'carAgeEnum' })
      if (code === 1) {
        this.carAgeOptions = data || []
      }
    },

    async fetchStoreList() {
      const { code, data } = await storeList({ pageNum: 1, pageSize: 999 })
      if (code === 1) {
        this.storeList = data?.items || []
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.operation-box {
  margin-bottom: 16px;
}
::v-deep .el-table {
  .operate-btns {
    .cell {
      display: flex;
    }
  }
  .product-link {
    margin-left: 0;
  }
}
</style>
